export interface LevelBrick {
  col: number;
  row: number;
  hp: number;
  kind: 'normal' | 'armored' | 'explosive' | 'bonus';
}

export interface LevelDefinition {
  name: string;
  rows: number;
  cols: number;
  speed: number;
  bricks: LevelBrick[];
}

const makeLevel = (
  name: string,
  rows: number,
  cols: number,
  speed: number,
  selector: (row: number, col: number) => LevelBrick['kind'] | null
): LevelDefinition => {
  const bricks: LevelBrick[] = [];
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const kind = selector(row, col);
      if (!kind) continue;
      bricks.push({
        col,
        row,
        kind,
        hp: kind === 'armored' ? 2 : 1
      });
    }
  }
  return { name, rows, cols, speed, bricks };
};

export const LEVELS: LevelDefinition[] = [
  makeLevel('霓虹启动', 5, 11, 360, (r, c) => {
    if ((r === 0 || r === 4) && c % 2 === 1) return null;
    if (r === 2 && (c === 2 || c === 8)) return 'bonus';
    if (r === 1 && c === 5) return 'explosive';
    return 'normal';
  }),
  makeLevel('能量回廊', 6, 12, 395, (r, c) => {
    if ((r + c) % 5 === 0) return null;
    if ((r === 1 || r === 4) && c % 4 === 0) return 'armored';
    if (r === 2 && (c === 3 || c === 8)) return 'explosive';
    if (r === 5 && (c === 1 || c === 10)) return 'bonus';
    return 'normal';
  }),
  makeLevel('核心防线', 7, 13, 430, (r, c) => {
    const center = 6;
    if (Math.abs(c - center) > 6 - r && r < 4) return null;
    if (r === 0 || r === 6 || c === 0 || c === 12) return 'armored';
    if ((r === 2 || r === 4) && (c === 3 || c === 9)) return 'explosive';
    if (r === 3 && c === 6) return 'bonus';
    return 'normal';
  })
];

export function seededDailyLevel(seed: number): LevelDefinition {
  let value = seed >>> 0;
  const rand = () => {
    value = (value * 1664525 + 1013904223) >>> 0;
    return value / 4294967296;
  };
  return makeLevel('每日挑战', 7, 13, 415, (r, c) => {
    if (rand() < 0.14) return null;
    const roll = rand();
    if (roll < 0.09) return 'armored';
    if (roll < 0.14) return 'explosive';
    if (roll < 0.19) return 'bonus';
    return 'normal';
  });
}
